import React, { useState } from 'react';
import { api } from '../api';

export function LoginPage({ onLogin, initialError = '', onClearError = null }) {
  const [accountName, setAccountName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(initialError || '');
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    setError(initialError || '');
  }, [initialError]);

  async function submit(e) {
    e.preventDefault();
    setError('');
    if (onClearError) onClearError();
    if (!accountName.trim() || !password) {
      setError('Введите account name и пароль');
      return;
    }
    try {
      setSubmitting(true);
      const result = await api('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ accountName, password })
      });
      onLogin(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <form className="card auth-card" onSubmit={submit}>
        <h1>Callnote</h1>
        <label>Account name<input value={accountName} onChange={(e) => setAccountName(e.target.value)} disabled={submitting} /></label>
        <label>Password<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={submitting} /></label>
        {error ? <div className="error">{error}</div> : null}
        <button type="submit" disabled={submitting}>{submitting ? 'Вход...' : 'Войти'}</button>
      </form>
    </div>
  );
}
